import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './shared/login/login.component';
import { MainComponent } from './shared/main/main.component';
import { DeletePopupComponent } from './shared/common/delete-popup/delete-popup.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { FrontLayoutComponent } from './layouts/front-layout/front-layout.component';
import { AdminSharedComponentsModule } from './module/admin/components/admin-shared-components.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SignUpComponent } from './shared/sign-up/sign-up.component';
import { RecoverCodeComponent } from './shared/recover-code/recover-code.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SignupQuestionComponent } from './shared/signup-question/signup-question.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ForgotPasswordComponent } from './shared/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './shared/change-password/change-password.component';
import { ManageColumnComponent } from './shared/manage-column/manage-column.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgOtpInputModule } from 'ng-otp-input';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SweetSpotViewLayoutComponent } from './layouts/sweet-spot-view-layout/sweet-spot-view-layout.component';
import { SweetSpotManageLayoutComponent } from './layouts/sweet-spot-manage-layout/sweet-spot-manage-layout.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { ResetPasswordComponent } from './shared/reset-password/reset-password.component';
import { VerifyOtpComponent } from './shared/verify-otp/verify-otp.component';
import { ConfirmForgetPasswordComponent } from './shared/confirm-forget-password/confirm-forget-password.component';
import { SetNewPasswordComponent } from './shared/set-new-password/set-new-password.component';
import { VerifyOtpMessageDialogueComponent } from './shared/verify-otp-message-dialogue/verify-otp-message-dialogue.component';
import { PasswordMessageDialogueComponent } from './shared/password-message-dialogue/password-message-dialogue.component';
import { LandingPageComponent } from './shared/landing-page/landing-page.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChangeEmailComponent } from './shared/change-email/change-email.component';
import { ConfirmationModalComponent } from './shared/confirmation-modal/confirmation-modal.component';
import { ChangeEmailVerficationComponent } from './shared/change-email-verfication/change-email-verfication.component';
import { MatNativeDateModule } from '@angular/material/core';
import { initApp } from './services/common/common.service';
import { StorageService } from './services/common/storage.service';
import { NoWhitespaceDirective } from './shared/directives/no-whitespace.directive';
import { NotificationComponent } from './shared/notification/notification/notification.component';
import { UnauthorizedComponent } from './shared/unauthorized/unauthorized.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { StateInactivePopupComponent } from './shared/state-inactive-popup/state-inactive-popup.component';
import { SocialMediaRegisterComponent } from './shared/social-media-register/social-media-register.component';
import { SocialMediaThankYouComponent } from './shared/social-media-thank-you/social-media-thank-you.component';
import { ExistingCustomerDialogComponent } from './shared/existing-customer-dialog/existing-customer-dialog.component';
import { ReferralConsentDialogComponent } from './shared/referral-consent-dialog/referral-consent-dialog.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MainComponent,
    DeletePopupComponent,
    AdminLayoutComponent,
    FrontLayoutComponent,
    SignUpComponent,
    RecoverCodeComponent,
    SignupQuestionComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    ManageColumnComponent,
    SweetSpotViewLayoutComponent,
    SweetSpotManageLayoutComponent,
    ResetPasswordComponent,
    VerifyOtpComponent,
    ConfirmForgetPasswordComponent,
    SetNewPasswordComponent,
    VerifyOtpMessageDialogueComponent,
    PasswordMessageDialogueComponent,
    LandingPageComponent,
    ChangeEmailComponent,
    ConfirmationModalComponent,
    ChangeEmailVerficationComponent,
    NotificationComponent,
    UnauthorizedComponent,
    StateInactivePopupComponent,
    SocialMediaRegisterComponent,
    SocialMediaThankYouComponent,
    ExistingCustomerDialogComponent,
    ReferralConsentDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AdminSharedComponentsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatInputModule,
    NgbModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSelectModule,
    MatAutocompleteModule,
    NgbNavModule,
    MatRadioModule,
    MatProgressBarModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    MatCardModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatTooltipModule,
    NoWhitespaceDirective,
    TranslateModule.forRoot({
      defaultLanguage: 'eng',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatProgressSpinnerModule
  ],
  exports: [
  ],
  providers: [
    ToastrService,
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,    // when initially load the page then clear the storage token
      useFactory: initApp,
      deps: [StorageService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
